<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">

    <div class="col-lg-12 col-md-12 col-12">
      <div class="card">
        <div class="card-body custom-datatable">
          <div class="row btn-showcase">
            <div class="col-md-3 form-group">
              <ng-multiselect-dropdown
              [placeholder]="'-- advertiser --'"
              [settings]="dropdownSettingsAdvertiser"
              [data]="dropdownListAdvertiser"              
              [(ngModel)]="selectedItemsAdvertiser"
              (onSelect)="onItemSelectAdvertiser($event)"
              >
              </ng-multiselect-dropdown>
            </div>

            <div class="col-md-3 form-group">
              <button class="btn btn-sm btn-pill btn-primary" type="button" ngbTooltip="import offers from single Advertiser"
                (click)="onImport()">Import</button>
              <button class="btn btn-sm btn-pill btn-primary" type="button" ngbTooltip="import offers from all Advertisers"
                (click)="onImportAll()">Import All</button>
            </div>
          </div>

          <ngx-datatable
          class='bootstrap'
          [rows]="importData"
          [columnMode]="ColumnMode.force"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [limit]="12"
          [sorts]="[{ prop: 'lastImportUtc', dir: 'desc' }]"
          >
          <ngx-datatable-column name="lastImportUtc">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Last import</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.lastImportUtc | date:'d/M/yyyy H:mm'}}
              <small class="badge badge-success" *ngIf="calculateDiff(row.lastImportUtc)==0">Today</small>
              <small class="badge badge-success" *ngIf="calculateDiff(row.lastImportUtc)==1">Yesterday</small>
              <small *ngIf="calculateDiff(row.lastImportUtc)>1">{{calculateDiff(row.lastImportUtc)}} days ago</small>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="advertiserName">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Advertiser</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.advertiserName }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="allOffers">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">All Offers</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.allOffers }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="expiredOffers">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Expired Offers</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.expiredOffers }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="activeOffers">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Active Offers</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.activeOffers }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="lockedOffers">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Locked Offers</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.lockedOffers }}
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
        <!-- <small><b>Note:</b> Import of offers from all advertisers is carried out once a day (every 24 hours)</small> -->
        <small><b>Note:</b>After pressing the import button, the process which takes a while has started. Refresh the page in a few moments to see the effect.</small>
      </div>
      </div>
    </div>
  </div>

</div>
<!-- Container-fluid Ends-->
